import React from 'react';
import { Star } from 'lucide-react';
interface RatingProps {
  value: number;
  count?: number;
  showCount?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Rating({
  value,
  count,
  showCount = true,
  size = 'sm',
  className = ''
}: RatingProps) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  const iconSize = sizes[size];
  const fullStars = Math.floor(value);
  const hasHalfStar = value % 1 !== 0;
  return <div className={`flex items-center gap-1.5 ${className}`} data-id="element-18348">
      <div className="flex text-amber-400" data-id="element-18349">
        {[...Array(5)].map((_, i) => {
        if (i < fullStars) {
          return <Star key={i} className={`${iconSize} fill-current`} data-id="element-18350" />;
        }
        if (i === fullStars && hasHalfStar) {
          // Simple half star representation using CSS clip-path or just a filled star with opacity for simplicity in this mockup
          return <div key={i} className="relative" data-id="element-18351">
                <Star className={`${iconSize} text-slate-200 fill-current`} data-id="element-18352" />
                <div className="absolute inset-0 overflow-hidden w-1/2" data-id="element-18353">
                  <Star className={`${iconSize} text-amber-400 fill-current`} data-id="element-18354" />
                </div>
              </div>;
        }
        return <Star key={i} className={`${iconSize} text-slate-200 fill-current`} data-id="element-18355" />;
      })}
      </div>
      {showCount && count !== undefined && <span className="text-sm text-slate-500 ml-1" data-id="element-18356">
          {value.toFixed(1)} ({count})
        </span>}
    </div>;
}